const API_ROUTES = {
  REFRESH_TOKEN: `/user-management/v1/refresh/authtoken`,
  LOGIN: `/user-management/v1/login/password`,
  NON_LOGIN: `/user-management/v1/generate/nonLogin`,
  DIAIKIN_LOGIN: `/user-management/v1/login/daikincity`,
  LOGOUT: `/user-management/v1/logout`,
  FORGOT_PASSWORD: ({ userName }) =>
    `/user-management/v1/reset/password/${userName}`,
  RESET_PASSWORD: `/user-management/v1/save/password`,
  CHANGE_PASSWORD: `/user-management/v1/password`,
  ADD_NEW_USER: `user-management/v1/add/newuser`,
  UPDATE_USER: `user-management/v1/userprofile`,
  UPDATE_USER_CONTENT: `user-management/v1/user/content`,
  ADD_BUILDING: `user-management/v1/userbuilding`,
  GET_USER_PROFILE: id => `user-management/v1/userprofile/${id}`,
  GET_USER: ({ params }) => `user-management/v1/relation/users/${params}`,
  GET_BUILDING: ({ params }) => `user-management/v1/userbuilding/${params}`,
  SEARCH_USER: ({ params }) => `/user-management/v1/search/user/${params}`,
  ADD_ASSOCIATE: ({ params }) => `/user-management/v1/user/associate${params}`,
  DIS_ASSOCIATE: ({ params }) =>
    `/user-management/v1/user/disassociate${params}`,
  USER_VALIDATION: ({ params }) => `/user-management/v1/credvalidate${params}`,
  SEND_USER_REMINDER: `/user-management/v1/user-reminders`,
  RESOLVE_USER_REMINDER: ({ id }) =>
    `/user-management/v1/user-reminders/resolve?id=${id}`,
  GET_USER_REMINDERS: ({ pageNo, userId }) =>
    `/user-management/v1/user-reminders/${pageNo}?userId=${userId}`,
  GET_BRAND: ({ id }) => `/user-management/v1/brand/${id}`,
  GET_ALL_BRAND: ({ params }) => `/user-management/v1/all/brand/${params}`,
  GET_IMAGE_FILE: ({ params }) => `/user-management/v1/file${params}`,
  DELETE_IMAGE_FILES: ({ params }) => `/user-management/v1/files${params}`,
  ADD_BRAND: ({ params }) => `user-management/v1/brand${params}`,
  SEARCH_BRAND: ({ params }) => `/user-management/v1/search/brand/${params}`,
  GET_JOB_LIST: ({ params }) => `/job-management/v1/job/${params}`,
  GET_PENDING_ACTIONS_JOB_LIST: ({ pageNo, params }) =>
    `/job-management/v1/jobs/${pageNo}${params}`,
  SEARCH_JOB_LIST: ({ params }) => `/job-management/v1/search/job/${params}`,
  GET_ERROR_CODE: ({ pageNo, params }) =>
    `/job-management/v1/job/model/errorcode/${pageNo}${params}`,
  GET_JOB_DETAILS: ({ params }) => `/job-management/v1/job${params}`,
  GET_INVOICE_DETAILS: ({ pageNo, params }) =>
    `/job-management/v1/invoice-details/${pageNo}${params}`,
  FISCAL_YEARS: `/job-management/v1/fiscalyear`,
  JOBS_UPDATE: '/job-management/v1/job',
  GET_EQUIPMENT: ({ params }) => `/user-management/v1/all/ein/${params}`,
  SEARCH_EQUIPMENT: ({ params }) => `/user-management/v1/search/ein/${params}`,
  GET_ADDRESS_DATA: ({ params }) =>
    `/dataviz-management/v1/statecitylist${params}`,
  GET_EQUIPMENT_DATA: ({ params }) =>
    `/dataviz-management/v1/brand/jobs/${params}`,
  GET_EQUIPMENT_PIE_CHART_DATA: ({ params }) =>
    `/dataviz-management/v1/piechart${params}`,
  GET_TOTAL_USER_DATA: ({ params }) =>
    `/dataviz-management/v1/user/job/total${params}`,
  GET_FE_USER_DATA: ({ params }) =>
    `/dataviz-management/v1/brand/user/jobs/${params}`,
  ADD_ERROR_CODE: `/user-management/v1/errorcode`,
  GET_FILTER_USER_DATA: ({ userType, pageNo }) =>
    `/dataviz-management/v1/filter/${userType}/${pageNo}`,
  GET_SEARCH_FILTER_DATA: ({ userType, pageNo, search }) =>
    `/dataviz-management/v1/filter/search/${userType}/${pageNo}?search=${search}`,
  GET_BUILDING_DETAILS: ({ buildingId }) =>
    `/dataviz-management/v1/building/${buildingId}`,
  GET_EQUIPMENT_DETAILS: ({ buildingId, equipmentId }) =>
    `/dataviz-management/v1/building/${buildingId}/equipment/${equipmentId}`,
  GET_REPORT: ({ jobId, jobType }) =>
    `/job-management/v1/report?jobId=${jobId}&jobType=${jobType}`,
  GET_BRAND_TOTAL: ({ params }) =>
    `/dataviz-management/v1/brand/jobs/total${params}`,
  SHARE_REPORT: `/job-management/v1/email-sms`,
  UPDATE_REPORT: `/job-management/v1/updation/report`,
  GET_COUNTRY_STATE: ({ params }) =>
    `/dataviz-management/v1/dashboard/statecitylist${params}`,
  GET_TILES: ({ params }) => `/dashboard-management/v1/tiles${params}`,
  GET_PIE_CHART: ({ params }) =>
    `/dashboard-management/v1/scrapsource${params}`,
  GET_ERROR_CODE_TABLE: ({ params }) =>
    `/dataviz-management/v1/dashboard/table/${params}`,
  GET_BAR_CHART: ({ params }) =>
    `/dataviz-management/v1/dashboard/barchart/${params}`,
  GET_TOTAL_JOBS: ({ params }) =>
    `/dashboard-management/v1/totalinput${params}`,
  GET_QUANTITY_OF_SCRAP: ({ params }) =>
    `dashboard-management/v1/quantityofscrap${params}`,
  GET_BUBBLE_CHART: ({ params }) =>
    `/dashboard-management/v1/bubblechart${params}`,
  GET_SCRAP_PIE_CHART_DATA: ({ params }) =>
    `/dashboard-management/v1/scrapsource/bucket${params}`,
  GET_BUCKET_QUANTITY: ({ params }) =>
    `/dashboard-management/v1/bucketquantity/${params}`,
  GET_DEALER_PAYMENT_LIST: ({ params }) =>
    `/dashboard-management/v1/dealerpayments/${params}`,
  GET_TAGS_LIST: `/user-management/v1/tags`,
  GET_SEARCH_TAG: ({ params }) => `/user-management/v1/search/tags${params}`,
  GET_INVENTORY_LIST: ({ params }) => `/job-management/v1/inventory/${params}`,
  GET_SCRAP_LIST: ({ params }) => `/job-management/v1/scrap/${params}`,
  GET_JOB_FOR_SCRAP_LIST: ({ params }) =>
    `/job-management/v1/jobforscrap/${params}`,
  GET_ALL_CATEGORY: 'user-management/v1/category',
  GET_REPORT_LIST: ({ params }) => `/job-management/v1/reporttable/${params}`,
  POST_EXPORT_TO_EXCEL: `/job-management/v1/userreports`,
  GET_COLUMN_LIST: ({ params }) => `/job-management/v1/reportcolumn${params}`,
  GET_REPORT_HISTORY_LIST: ({ params }) =>
    `/job-management/v1/userreports/${params}`,
  GET_CATEGORY_API: `/user-management/v1/category`,
  GET_SELECT_CATEGORY: `/user-management/v1/tags?type=BUCKET_NAME`,
  ADD_CATEGORY: `/user-management/v1/category`,
  EDIT_CATEGORY: `/user-management/v1/category`,
  DELETE_CATEGORY: ({ id }) => `/user-management/v1/category?categoryId=${id}`,
  QUICK_EDIT: `/job-management/v1/elv`,
  UPDATE_SCRAP_CATEGORY: ({ params }) =>
    `/job-management/v1/scrap/category${params}`,
  GET_GEO_TAG: ({ params }) => `/job-management/v1/geotag${params}`,
  GET_MACHINE_FOUNDRY: ({ params }) =>
    `/job-management/v1/machine/foundry/scrap${params}`,
  GET_PART_SCRAP: ({ params }) => `/job-management/v1/parts/scrap/${params}`,
  GET_SALES_REPORT_LIST: ({ params }) =>
    `/job-management/v1/salesreporttable/${params}`,
  GET_STOCK_REPORT_LIST: ({ params }) =>
    `/job-management/v1/stockreporttable${params}`,
  ALL_ADDRESS_DATA: ({ params }) =>
    `/user-management/v1/allcountrydata${params}`,
  GET_OCR_DATA: `/job-management/v1/ocr`,
  GET_OCR_RESULT: ({ id }) => `/job-management/v1/ocr/${id}`,
  JOB_EDIT_LOG: ({ params = '' } = {}) => `/job-management/v1/editlog${params}`,
  PROCESS_ELV: `/job-management/v1/processelv`,
  GET_VEHICLE_MODEL_LIST: ({ params }) => `/user-management/v1/model/${params}`,
  ADD_VEHICLE_MODEL: `/user-management/v1/model`,
  SEARCH_VEHICLE_MODEL_LIST: ({ params }) =>
    `/user-management/v1/search/model/${params}`,
  GET_FLEXIBLE_REPORT_DATA: ({ pageNo }) =>
    `/job-management/v1/flexible_report/${pageNo}`,
  SAVE_FLEXIBLE_REPORT: `/job-management/v1/flexible_report_filter`,
  GET_SAVE_FLEXIBLE_REPORT: ({ params }) =>
    `/job-management/v1/flexible_report_filter/${params}`,
  GET_SINGLE_REPORT: ({ params }) =>
    `/job-management/v1/flexible_report_filter?id=${params}`,
  GET_FLEXIBLE_REPORT_CALCULATION: `/job-management/v1/flexible_report_calculation`,
  GET_SINGLE_ACTIVE_JOBS_REPORT: ({ params }) =>
    `/job-management/v1/flexible_report_filter?id=${params}`,
  GET_GENERATED_REPORT: ({ params }) => `/job-management/v1/report${params}`,
  GET_LOCATION_LIST: ({ params }) =>
    `/user-management/v1/locationdata/${params}`,
  GET_CHANNEL_LIST: ({ params }) =>
    `/user-management/v1/getUserLocationChannel${params}`,
  GET_MATERIAL_QUANTITY_LIST: ({ params }) =>
    `/dashboard-management/v1/materialquantity/${params}`,
  GET_DEALER_PAYMENT_COMPARISON: ({ params }) =>
    `/dashboard-management/v1/paymentcomparison${params}`,
  GET_NOTIFICATION_COUNT: ({ jobType }) =>
    `/job-management/v1/jobdetails?jobType=${jobType}`,
  GET_PENDING_ACTIONS_COUNT: ({ params }) =>
    `/job-management/v1/jobdetails${params}`,
  GET_JOB_SCRAP: ({ params }) => `/job-management/v1/jobscrap${params}`,
  BATCH_NUMBER: '/job-management/v1/batchnumber',
  BULK_UPLOAD: `job-management/v1/jobbulkupload`,
  UPLOAD_EXCEL: ({ params }) => `/job-management/v1/upload/excel${params}`,
  GET_BULK_UPLOAD_LIST: ({ params }) =>
    `/job-management/v1/jobfileUploads/${params}`,
  SINGLE_BULK_UPLOAD: ({ params }) =>
    `job-management/v1/jobfileuploadsdetails/${params}`,
  GET_MATERIAL_PIE_CHART: ({ params }) =>
    `/dashboard-management/v1/materialpiechart${params}`,
  GET_MATERIAL_QUANTITY_BAR_CHART: ({ params }) =>
    `/dashboard-management/v1/barchartquantity${params}`,
  GET_TOTAL_OVERVIEW_CHART: ({ params }) =>
    `/dashboard-management/v1/totaloverviewchart${params}`,
  GET_TABLE_CHART_QUANTITY: ({ params }) =>
    `/dashboard-management/v1/tablechartquantity${params}`,
  GET_COGS_PIE_CHART: ({ params }) =>
    `/dashboard-management/v1/totalcogspiechart${params}`,
  GET_COGS_TABLE_CHART: ({ params }) =>
    `/dashboard-management/v1/cogstablechart${params}`,
  GET_COGS_BAR_CHART: ({ params }) =>
    `/dashboard-management/v1/cogsbarchart${params}`,
  GET_MATERIAL_SALES_TABLE_CHART: ({ params }) =>
    `/dashboard-management/v1/materialsalestablechart${params}`,
  GET_MATERIAL_SALES_BAR_CHART: ({ params }) =>
    `/dashboard-management/v1/materialsalesbarchart${params}`,
  CATEGORY_EDIT_LOG: ({ params }) =>
    `/user-management/v1/category/editlog${params}`,
  USER_BATCH_NUMBER: `/job-management/v1/user-batchnumber`,
  UPDATE_VEHICLE_DISPATCH_DATE: `/job-management/v1/vehicle-dispatch-date`,
  SEARCH_INVENTORY: ({ params }) =>
    `/job-management/v1/search/inventory/${params}`,
  GET_SCRAP_MATERIALS: ({ params }) =>
    `/job-management/v1/scrapMaterials${params}`,
  GET_SCRAP_LIST_ON_MATERIAL_TYPE: ({ params }) =>
    `/job-management/v1/scrapListOnMaterialType${params}`,
  GET_INFO_TILL_JOB: ({ params }) => `/job-management/v1/infotilljob${params}`,
  GET_CONNECTED_JOBS: ({ jobId, page = 1 }) =>
    `/job-management/v1/connectedjobs/${jobId}/${page}`,
  GET_ELV_LIST: `/job-management/v1/dispatchscraps`,
  GET_PREVIOUS_JOB: `/job-management/v1/previous/job`,
  PART_NUMBER: ({ pageNo } = {}) =>
    `/job-management/v1/partnumber${pageNo ? `/${pageNo}` : ''}`,
  DOWNLOAD_TEMPLATE: ({ params }) => `/job-management/v1/template${params}`,
  GET_FILE_UPLOAD_DETAILS: ({ pageNo }) =>
    `/job-management/v1/jobfileuploadsdetails/${pageNo}`,
  GET_PART_CATEGORY: `/job-management/v1/category`,
  GET_DASHBOARD_RECYCLE_CONTENT: `/dashboard-management/v1/recycled-content`,
  SET_MATERIAL_TARGET: `/job-management/v1/material-fiscal-year-target`,
  INVOICE_NUMBER_VALIDATION: `/job-management/v1/invoice-number`,
  PAYMENT_FORM_GENERATION: `/job-management/v1/paymentform`,
  GET_SEARCH_INVENTORY: ({ params }) =>
    `/job-management/v1/search/scrap/${params}`,
  UPDATE_SCRAP_CREDIT_NOTE: `/job-management/v1/scrap/credit-note`,
}
export default API_ROUTES
